<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-simple-table dense style="border: 1px solid #d1d1d1">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left caption">CUENTA</th>
                <th class="text-left caption">CONTABLE</th>
                <th v-for="(sede, indiceSede) in sedes" :key="indiceSede" class="text-right caption">
                  <span :title="`${sede.id} - ${sede.nombre}`">{{ sede.nombre }}</span>
                </th>
                <th class="text-right caption">TOTAL</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(estimacion, indice) in estimacionesSedesPorPartidas" :key="indice">
                <td class="text-left caption">{{ estimacion.codigo }} {{ estimacion.clasificador_nombre }}</td>
                <td class="text-left caption">
                  {{ estimacion.cuenta_contable_codigo }} {{ estimacion.cuenta_contable_nombre }}
                </td>
                <td v-for="(sede, indiceSede1) in sedes" :key="indiceSede1" class="text-right caption">
                  {{ formatearValorAMoneda(estimacion[sede.id]) }}
                </td>
                <td class="text-right caption">{{ formatearValorAMoneda(estimacion.total) }}</td>
              </tr>

              <tr>
                <td></td>
                <td class="text-left caption">TOTALES</td>
                <td v-for="(sede, indiceSede2) in sedes" :key="indiceSede2" class="text-right caption">
                  {{ formatearValorAMoneda(totalEstimacionesSedesPorPartidas[sede.id]) }}
                </td>
                <td class="text-left caption">{{ formatearValorAMoneda(totalEstimacionesSedesPorPartidas?.total) }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { formatearValorAMoneda } from './../../utils.js';

export default {
  name: 'ReporteConsolidadoPorSedeYMes',
  props: {
    estimacionesSedesPorPartidas: {
      type: Array,
      default: () => [],
    },
    sedes: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    formatearValorAMoneda(numero) {
      if (numero) {
        return formatearValorAMoneda(numero);
      }

      return 0.0;
    },
  },
  computed: {
    totalEstimacionesSedesPorPartidas() {
      const totales = {};
      this.estimacionesSedesPorPartidas.map((estimacion) => {
        Object.keys(estimacion).map((key) => {
          if (key != 'codigo' && key != 'clasificador_nombre') {
            if (totales[key]) {
              totales[key] += parseFloat(estimacion[key]);
            } else {
              totales[key] = parseFloat(estimacion[key]);
            }
          }
        });
      });

      return totales;
    },
  },
};
</script>

<style>
</style>